import {avisoAguarde, retirarAguarde} from "./utils";

let lotoConfig = null;
let lotoTipo = 'seninha';
let selectedNumbers = [];
let selectedSelecoes = 0;
let lotoCart = [];
let lotoMode = false;

let _origPanelHtml = null;
let _origConsultarJogos = null;

const RANGE = {seninha: 60, quininha: 80};

export function initLotinha() {
  $('#grdJogosLive').hide();
  $('#grdJogos').show();

  avisoAguarde();

  $.ajax({
    url: url + "enet/getLotoConfig",
    type: "GET",
    dataType: "json",
    success: function (data) {
      lotoConfig = data;
      retirarAguarde();
      if (!data.ativo) {
        $('#grdJogos').html("<div style='padding:20px;'>Lotinha não disponível no momento.</div>");
        return;
      }
      lotoTipo = 'seninha';
      selectedNumbers = [];
      lotoCart = [];
      resetSelecoes();
      enterLotoMode();
      renderGrid();
      updateLotoTicket();
      updateLotoRodape();
    },
    error: function () {
      retirarAguarde();
      $('#grdJogos').html("<div style='padding:20px;'>Erro ao carregar Lotinha.</div>");
    }
  });
}

// ─── mode management ──────────────────────────────────────────────────────────

function enterLotoMode() {
  if (lotoMode) return;
  lotoMode = true;

  // save original panel
  _origPanelHtml = $('#panelRodape').html();

  // inject loto-specific panel (same IDs, adapted labels + buttons)
  $('#panelRodape').html(`
    <table border='0' cellpadding='4' cellspacing='4' class="tabelaInf">
      <tr align="right">
        <td width='50%'>N. de Itens:</td>
        <td><span id="lbNJogos">0</span></td>
      </tr>
      <tr align="right">
        <td>Valor por item:</td>
        <td><input id="EditVlAposta" type="text" class="campValor" style="width:80px;"/></td>
      </tr>
      <tr align="right">
        <td>Prêmio estimado:</td>
        <td><span id="lbLotoPremio" style="color:#1a7c3e;font-weight:bold;">—</span></td>
      </tr>
      <tr align="right">
        <td colspan="2">
          <button type="button" class="botao" onclick="window.lotoAddItem()"
            style="width:95%;font-size:12px;padding:4px;">Adicionar</button>
        </td>
      </tr>
      <tr align="right">
        <td>Total apostado:</td>
        <td><span id="lbVlTaxaTotal">0,00</span></td>
      </tr>
      <tr align="right">
        <td>Cliente:</td>
        <td><input id="EditCliente" type="text" class="campValor"/></td>
      </tr>
    </table>
    <br/><br/>
    <input id="btConfirmar" type="button" value="Confirmar" class="botao" style="width: 45%"
      onclick="window.lotoConfirmar();"/>
    <input id="btLimpar" type="button" value="Limpar" class="botao" style="width: 45%"
      onclick="window.lotoLimpar();"/>
  `);

  // bind prize update on value change
  $(document).on('input.loto change.loto', '#EditVlAposta', function () {
    updateLotoPremiacao();
  });

  // wrap ConsultarJogos so navigating away exits loto mode first
  _origConsultarJogos = window.ConsultarJogos;
  window.ConsultarJogos = function (id) {
    exitLotoMode();
    _origConsultarJogos(id);
  };
}

function exitLotoMode() {
  if (!lotoMode) return;
  lotoMode = false;

  // restore panel
  if (_origPanelHtml !== null) {
    $('#panelRodape').html(_origPanelHtml);
    _origPanelHtml = null;
  }

  // remove loto-specific listeners
  $(document).off('.loto');

  // restore ConsultarJogos
  if (_origConsultarJogos !== null) {
    window.ConsultarJogos = _origConsultarJogos;
    _origConsultarJogos = null;
  }

  // restore sports bilhete
  window.MontaBilhete && window.MontaBilhete();

  // re-bind the value change listener the default.js sets up
  $("#EditVlAposta").on("change paste keyup", function () {
    window.CalcularGanho && window.CalcularGanho();
  });
}

// ─── helpers ──────────────────────────────────────────────────────────────────

function getPremios() {
  return lotoTipo === 'seninha' ? lotoConfig.premios_seninha : lotoConfig.premios_quininha;
}

function getConcurso() {
  return lotoTipo === 'seninha' ? lotoConfig.concurso_seninha : lotoConfig.concurso_quininha;
}

function getValidSelecoes() {
  return getPremios().map(p => p.selecoes);
}

function resetSelecoes() {
  const validos = getValidSelecoes();
  selectedSelecoes = validos.length ? validos[0] : 0;
}

// ─── rendering ────────────────────────────────────────────────────────────────

function renderGrid() {
  const concurso = getConcurso();
  const premios = getPremios();

  const concursoHtml = concurso
    ? `Concurso: <b>${concurso.numero}</b> &nbsp; Data: <b>${concurso.start_date}</b>`
    : '<span style="color:red;">Nenhum concurso disponível</span>';

  const selectOptions = premios.map(p =>
    `<option value="${p.selecoes}" ${p.selecoes === selectedSelecoes ? 'selected' : ''}>` +
    `${p.selecoes} números (x${p.multiplicador})</option>`
  ).join('');

  const gridHtml = concurso ? `
    <div style="margin:8px 0;">
      Quantidade:
      <select id="loto-selecoes" onchange="window.lotoChangeSelecoes()" style="margin-left:4px;">
        ${selectOptions}
      </select>
      &nbsp;
      <button type="button" class="botao" onclick="window.lotoSurpresa()" style="width:100px;">Surpresa!</button>
    </div>
    <div style="margin:6px 0;">
      <b>Selecione ${selectedSelecoes} números:</b>
      &nbsp;<span id="loto-sel-count" style="font-weight:bold;">${selectedNumbers.length}</span>/${selectedSelecoes}
      &nbsp;<span id="loto-sel-nums" style="color:#555;">${selectedNumbers.join(', ')}</span>
    </div>
    <div id="loto-grid" style="display:flex;flex-wrap:wrap;gap:4px;max-width:700px;margin:8px 0;">
      ${buildGridButtons(RANGE[lotoTipo] || 60)}
    </div>
  ` : '';

  $('#grdJogos').html(`
    <div style="padding:10px;">
      <table width="100%">
        <tr id="header" style="color:#fff;"><td><b>Lotinha</b></td></tr>
      </table>
      <div style="margin:8px 0;">
        <button type="button" class="botao" onclick="window.lotoSetTipo('seninha')"
          style="width:120px;${lotoTipo === 'seninha' ? '' : 'opacity:0.6;'}">Seninha</button>
        <button type="button" class="botao" onclick="window.lotoSetTipo('quininha')"
          style="width:120px;margin-left:5px;${lotoTipo === 'quininha' ? '' : 'opacity:0.6;'}">Quininha</button>
      </div>
      <div style="margin:4px 0;">${concursoHtml}</div>
      ${gridHtml}
    </div>
  `);
}

function buildGridButtons(range) {
  let html = '';
  for (let i = 1; i <= range; i++) {
    const sel = selectedNumbers.includes(i);
    html += `<button type="button" id="loto-n-${i}" onclick="window.lotoToggleNum(${i})"
      style="width:36px;height:36px;border-radius:50%;border:1px solid #aaa;cursor:pointer;
             background:${sel ? '#1a7c3e' : '#eee'};color:${sel ? '#fff' : '#333'};">${i}</button>`;
  }
  return html;
}

function updateLotoTicket() {
  if (lotoCart.length === 0) {
    $('#grdApostas').html(`
      <table border='0' cellpadding='2' cellspacing='2' class="tabelaBilhete">
        <tr class="tabelaBilheteTitulo"><th>Seleções</th><th width='10%'>&nbsp;</th></tr>
      </table>
    `);
    return;
  }

  const rows = lotoCart.map((item, idx) => `
    <tr class="${idx % 2 === 0 ? 'tabelaBilheteTituloLinhaImpar' : ''}">
      <td>
        <b>${item.tipo}</b> — Concurso ${item.concurso}<br/>
        Números: ${item.numeros}<br/>
        Valor: R$ ${item.valor.toFixed(2)} &nbsp;|&nbsp;
        Prêmio: <span style="color:#1a7c3e;font-weight:bold;">R$ ${item.premio.toLocaleString('pt-BR', {minimumFractionDigits:2,maximumFractionDigits:2})}</span>
      </td>
      <td><a href="javascript:window.lotoRemoveItem(${idx})">Excluir</a></td>
    </tr>
  `).join('');

  $('#grdApostas').html(`
    <table border='0' cellpadding='2' cellspacing='2' class="tabelaBilhete">
      <tr class="tabelaBilheteTitulo"><th>Seleções</th><th width='10%'>&nbsp;</th></tr>
      ${rows}
    </table>
  `);
}

function updateLotoRodape() {
  const total = lotoCart.reduce((sum, item) => sum + item.valor, 0);
  $('#lbNJogos').text(lotoCart.length);
  $('#lbVlTaxaTotal').text(total.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}));
}

function updateLotoPremiacao() {
  const el = document.getElementById('lbLotoPremio');
  if (!el) return;
  const valorStr = ($('#EditVlAposta').val() || '').replace(',', '.');
  const valor = parseFloat(valorStr);
  const premios = getPremios();
  const premio = premios.find(p => p.selecoes === selectedSelecoes);
  if (!premio || isNaN(valor) || valor <= 0) {
    el.textContent = '—';
    return;
  }
  const estimado = valor * premio.multiplicador;
  el.textContent = 'R$ ' + estimado.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});
}

function updateSelectionDisplay() {
  const countEl = document.getElementById('loto-sel-count');
  const numsEl = document.getElementById('loto-sel-nums');
  if (countEl) countEl.textContent = selectedNumbers.length;
  if (numsEl) numsEl.textContent = selectedNumbers.join(', ');
}

// ─── window actions ───────────────────────────────────────────────────────────

window.lotoSetTipo = function (tipo) {
  lotoTipo = tipo;
  selectedNumbers = [];
  resetSelecoes();
  renderGrid();
};

window.lotoChangeSelecoes = function () {
  const sel = document.getElementById('loto-selecoes');
  if (!sel) return;
  selectedSelecoes = parseInt(sel.value);
  if (selectedNumbers.length > selectedSelecoes) {
    selectedNumbers = selectedNumbers.slice(0, selectedSelecoes);
  }
  updateSelectionDisplay();
  updateLotoPremiacao();
  const range = RANGE[lotoTipo] || 60;
  const gridEl = document.getElementById('loto-grid');
  if (gridEl) gridEl.innerHTML = buildGridButtons(range);
};

window.lotoSurpresa = function () {
  const range = RANGE[lotoTipo] || 60;
  const pool = Array.from({length: range}, (_, i) => i + 1);
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  selectedNumbers = pool.slice(0, selectedSelecoes).sort((a, b) => a - b);
  updateSelectionDisplay();
  const gridEl = document.getElementById('loto-grid');
  if (gridEl) gridEl.innerHTML = buildGridButtons(range);
};

window.lotoToggleNum = function (num) {
  const idx = selectedNumbers.indexOf(num);
  if (idx > -1) {
    selectedNumbers.splice(idx, 1);
  } else {
    if (selectedNumbers.length >= selectedSelecoes) return;
    selectedNumbers.push(num);
    selectedNumbers.sort((a, b) => a - b);
  }
  const btn = document.getElementById('loto-n-' + num);
  if (btn) {
    const sel = selectedNumbers.includes(num);
    btn.style.background = sel ? '#1a7c3e' : '#eee';
    btn.style.color = sel ? '#fff' : '#333';
  }
  updateSelectionDisplay();
};

window.lotoAddItem = function () {
  if (selectedNumbers.length !== selectedSelecoes) {
    alert('Selecione exatamente ' + selectedSelecoes + ' números.');
    return;
  }
  const valorStr = ($('#EditVlAposta').val() || '').replace(',', '.');
  const valor = parseFloat(valorStr);
  if (isNaN(valor) || valor <= 0) {
    alert('Informe o valor da aposta.');
    return;
  }
  if (valor < lotoConfig.min_valor) {
    alert('Valor mínimo: R$ ' + lotoConfig.min_valor.toFixed(2));
    return;
  }
  if (valor > lotoConfig.max_valor) {
    alert('Valor máximo: R$ ' + lotoConfig.max_valor.toFixed(2));
    return;
  }
  const concurso = getConcurso();
  const premioItem = getPremios().find(p => p.selecoes === selectedSelecoes);
  const premio = premioItem ? valor * premioItem.multiplicador : 0;
  lotoCart.push({
    tipo: lotoTipo,
    concurso: concurso.numero,
    numeros: selectedNumbers.join(','),
    total_numeros: selectedNumbers.length,
    valor: valor,
    premio: premio,
  });
  selectedNumbers = [];
  renderGrid();
  updateLotoTicket();
  updateLotoRodape();
};

window.lotoRemoveItem = function (idx) {
  lotoCart.splice(idx, 1);
  updateLotoTicket();
  updateLotoRodape();
};

window.lotoLimpar = function () {
  lotoCart = [];
  selectedNumbers = [];
  renderGrid();
  updateLotoTicket();
  updateLotoRodape();
};

window.lotoConfirmar = function () {
  if (lotoCart.length === 0) {
    alert('Adicione pelo menos um jogo.');
    return;
  }
  if (!confirm('Deseja confirmar esta aposta de Lotinha?')) return;

  const nomeCliente = $('#EditCliente').val() || '';

  const body = {
    nome_cliente: nomeCliente,
    itens_aposta: lotoCart.map(item => ({
      tipo: item.tipo,
      concurso: item.concurso,
      numeros: item.numeros,
      total_numeros: item.total_numeros,
      valor: item.valor,
    })),
  };

  avisoAguarde();

  $.ajax({
    url: url + "enet/loto",
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: JSON.stringify(body),
    success: function (data) {
      retirarAguarde();
      if (data.sucesso) {
        const cod = data.codigo + '' + data.dv;
        alert('Bilhete confirmado! Código: ' + cod);
        if (window.config && window.config.Auth && window.config.Auth.LOGIN) {
          window.open(url + "enet/bilhetetxt/" + cod, "popup_window",
            "height=650,width=850,resizable=no,scrollbars=yes,location=no");
        }
        lotoCart = [];
        selectedNumbers = [];
        window.SaldoUser && window.SaldoUser();
        renderGrid();
        updateLotoTicket();
        updateLotoRodape();
      } else {
        alert(data.mensagem || 'Erro ao confirmar aposta.');
      }
    },
    error: function () {
      retirarAguarde();
      alert('Erro ao confirmar aposta.');
    }
  });
};
